var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dropleft dropdown-submenu clickable",
      on: {
        mouseenter: _vm.handleShowTooltip,
        mouseleave: _vm.handleHideTooltip,
      },
    },
    [
      _c(
        "a",
        {
          staticClass: "dropdown-toggle",
          attrs: { "data-toggle": "dropdown" },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("global.actions.moveTo")) + "\n  ")]
      ),
      _vm._v(" "),
      _c("boards-dropdown", {
        attrs: { boards: _vm.BOARDS, "board-id": _vm.boardId },
        on: { select: _vm.handleBoardSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }